import * as React from 'react';
import { connect } from 'react-redux';
import * as CollisionModel from '../../../Models/CollisionModel';
import { VehicleSpeedIcons, VehicleSpeedImage, CarNameBlock,CarVinBlock,CarAdressBlock,CarPathComponent } from '../../Map/CarDetails/Composites/_CompositesHelpers';
import { withTranslation  } from 'react-i18next';
import { VehicleSpeedEnum, CarCategory } from '../../../Models/EnumTypes/VehicleEnumTypes';
import { RootState } from 'Redux/Reducers/_RootReducer';
import { HistoryCollisionSelectors } from 'Redux/Selectors/CollisionSelectors'

type ConnectedProps = {
    carCollision: CollisionModel.CarCollisionDto,
    activeDataframesSpeed: CollisionModel.CarSpeedDataframeDto
};
type DispatchedProps = {
    t?: Function;
};
type S = {
    saveNotesChanges: boolean;
    carName: string;
    carImageSource: any;
    carImageVisible: boolean;
    noCarPhotosAvailable: boolean;
};

export class CollisionDetails extends React.Component<DispatchedProps & ConnectedProps,any> {

    public render() {
        const {t,carCollision,activeDataframesSpeed} = this.props;

        if(carCollision && activeDataframesSpeed) {
            return (
                <div className="carDetailsComposite">
                    <div className="carDetailsComposite__element carDetailsComposite__speedInfo">
                        <VehicleSpeedIcons
                            allowedSpeed={activeDataframesSpeed.speedLimitKmh}
                            currentSpeed={activeDataframesSpeed.speedGps}
                            turnedOn={true}
                            speedLimitExceedance={VehicleSpeedEnum.GREEN}
                        />
                        <VehicleSpeedImage
                            carCategory={CarCategory.VAN}
                            turnedOn={true}
                            speedLimitExceedance={VehicleSpeedEnum.GREEN}
                        />
                    </div>
                    <CarNameBlock 
                        carName={carCollision.vin}
                        licensePlate={carCollision.licensePlate}
                        noCarPhotosAvailable={false}
                        noImageAvailableInfo={t('noImageAvailable')}
                    />
    
                    {/* <CarVinBlock 
                        vin="TESTVIN"
                        deviceId="1234"
                        labelCarId={t('carId')}
                    /> */}
                    <CarAdressBlock
                        addressDisplayName={activeDataframesSpeed.address?activeDataframesSpeed.address.addressDisplayName:'-'}
                        latitude={activeDataframesSpeed.latitude}
                        longitude={activeDataframesSpeed.longitude}
                    />
    
                    <CarPathComponent 
                        carCategory={CarCategory.VAN}
                        mileageGps={activeDataframesSpeed.mileageGps}
                        speedGps={activeDataframesSpeed.speedGps}
                        turnedOn={true}
                        speedLimitKmh={activeDataframesSpeed.speedLimitKmh}
                        durationSeconds={activeDataframesSpeed.timeSinceLastParkingSeconds} 
                        endDate={null}
                        startDate={null}
                        t={t} 
                        onTourSince={null} 
                    />
                </div>
            )
        } else {
            return (
                <div className="carDetailsComposite">
                    ...
                </div>
            )
        }

    }
}

function mapStateToProps(state: RootState): ConnectedProps {
    return {
        carCollision: state.historyCollision.carCollision,
        activeDataframesSpeed: HistoryCollisionSelectors.getActiveSpeedDataframe(state)
    };
}

export default withTranslation ('carDetails')(
    connect(
        mapStateToProps,
        null
    )(CollisionDetails) as React.ComponentType<any>
);



// WEBPACK FOOTER //
// ./src/components/Layout/DetailsSidebar/CollisionDetails.tsx